import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { INotificationsService, INOTIFICATIONS_SERVICE } from '@platform500services/p500-ui-kit';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, take } from 'rxjs/operators';
import { AuthServiceInterface } from '../services/auth/auth-service.interface';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    protected localStorage: StorageMap,
    @Inject(INOTIFICATIONS_SERVICE) private notificationsService: INotificationsService,
    private router: Router,
    @Inject('AuthServiceInterface') private authService: AuthServiceInterface,
    private route: ActivatedRoute
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('affiliate-token');
    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next.handle(authRequest).pipe(
      catchError((err) => {
        this.showErrorsMsgs(err.error);
        if (err.status === 401) {
          this.route.queryParams.pipe(take(2), delay(100)).subscribe((params) => {
            this.authService.logout();
            this.router.navigate(
              ['/auth/signin'],
              params.logout ? { queryParams: { logout: true, error: err.error.error } } : { queryParams: { error: err.error.error } }
            );
          });
        }
        return throwError(err);
      })
    );
  }

  private showErrorsMsgs(data: any) {
    switch (Object.keys(data)[0]) {
      case 'validation_errors':
        Object.entries(data.validation_errors).forEach(([, value]) => {
          (value as string[]).forEach((error: string) => this.addMsg(error));
        });
        break;
      case 'error': {
        const msg = typeof data.error === 'string' ? data.error : data.error.message;
        if (data.error?.otp) {
          break;
        }
        this.addMsg(msg);
        break;
      }
      case 'message': {
        let type: 'error' | 'success' = 'error';
        if (data.message === 'The confirmation code was sent.') {
          type = 'success';
        }
        this.addMsg(data.message, type);
        break;
      }
      default:
        this.addMsg('Unknown error');
        break;
    }
  }

  private addMsg(title: string, type: 'error' | 'success' = 'error'): void {
    this.notificationsService.add({ type, title }, true);
  }
}
